import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

import { FieldTitleIw, FieldTitleIwProps } from './FieldTitleIw';
import { FieldTitleTooltipWrapperIw } from './FieldTitleTooltipWrapperIw';

export type FieldContainerIwProps = PropsWithChildren &
  FieldTitleIwProps & { tooltip?: string; className?: string };

export const FieldContainerIw: FC<FieldContainerIwProps> = ({
  children,
  label,
  required,
  tooltip,
  className,
}) => {
  return (
    <Container className={className}>
      {tooltip ? (
        <FieldTitleTooltipWrapperIw tooltip={tooltip}>
          <FieldTitleIw label={label} required={required} />
        </FieldTitleTooltipWrapperIw>
      ) : (
        <FieldTitleIw label={label} required={required} />
      )}

      {children}
    </Container>
  );
};

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
`;
